import React, { Component } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import BootstrapTable from "react-bootstrap-table-next";
import { Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import InputeEllipisWithTooltip from "../../../../Common/Components/InputeEllipisWithTooltip";
import { toast } from "react-toastify";
import _ from "lodash";

import {
  IRevenueEntryRequest,
  IRevenuePostRequest,
} from "../../../../Common/Contracts/IRevenueEntryRequest ";
import { Utils } from "../../../../Common/Utilis";

class RevenueNonRevenue extends Component<any, any> {
  private scrollPos: any;
  constructor(props: any) {
    super(props);
    this.scrollPos = React.createRef();
    this.state = {
      isModified: false,
      searchTerm: "",
      hideEmptyRows: false,
      data: [],
      hideDebitCredit: true,
      isDataLoading: false,
      isDataSaving: false,
    };
  }

  componentDidMount(): void {
    this.fetchRevenueData();
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.isLoadingDefaultDate &&
      (prevProps.selectedDate !== this.props.selectedDate ||
        prevProps.filterHotelId !== this.props.filterHotelId)
    ) {
      if (this.props.selectedDate) {
        this.fetchRevenueData();
      } else {
        this.setState({ data: [] });
      }
    }
  }

  fetchRevenueData = async () => {
    const { filterHotelId, selectedDate } = this.props;
    if (!filterHotelId || !selectedDate) {
      return;
    }

    this.setState({ searchTerm: "", isDataLoading: true });

    try {
      let revenueData =
        (await DailyActivityService.getDailyEntryRevenueDataBasedOnType(
          filterHotelId,
          selectedDate,
          this.props.type
        )) ?? [];

      const hideDebitCredit = revenueData?.some(
        (item) => item.entryType === "Single"
      );
      revenueData = revenueData.map((x: any) => {
        x.amount = x.amount
          ? Utils.currencyFormatWithOutdoller(x.amount)
          : x.amount;
        x.creditAmount = x.creditAmount
          ? Utils.currencyFormatWithOutdoller(x.creditAmount)
          : x.creditAmount;
        x.debitAmount = x.debitAmount
          ? Utils.currencyFormatWithOutdoller(x.debitAmount)
          : x.debitAmount;
        return x;
      });

      this.setState({ data: [] }, () => {
        this.setState({
          data: revenueData,
          hideDebitCredit,
          isDataLoading: false,
        });
      });
    } catch (error) {
      this.setState({ data: [], isDataLoading: false });
      console.error("Error fetching revenue data", error);
    } finally {
      if (this.state.isModified) {
        this.handleDiscard();
      }
    }
  };

  handleInputChange = (event, value, itemUniqueNo, field) => {
    const { data } = this.state;
    const rowIndex = data.findIndex(
      (x: any) => x.itemUniqueNo === itemUniqueNo
    );
    value = value?.toString()?.trimLeft();
    if (
      field === "debitAmount" ||
      field === "creditAmount" ||
      field === "amount"
    ) {
      if (
        value
          .toString()
          .split("")
          .findIndex((x) => x == ".") == 0 ||
        value.toString()?.split(".")?.length > 2
      ) {
        return;
      }

      Utils.AllowOnlyPositiveNumnberInput(event);
      value = value ? Utils.removeInvaildCharFromAmount(value) : value;
    }
    // if (
    //   field === "explanation" &&
    //   !/^[a-zA-Z0-9\s.,!?-]*$/.test(value.toString())
    // ) {
    //   return;
    // }

    this.setState((prevState) => {
      const newData = [...prevState.data];
      newData[rowIndex] = {
        ...newData[rowIndex],
        [field]: value,
        isModified: true,
      };
      this.props.setCurrentTabStatusOnValuesChanges(true);

      if (
        this.scrollPos?.current?.firstChild?.className ==
          "react-bootstrap-table" &&
        !this.state.isModified
      ) {
        if (!this.state.searchTerm?.trim()) {
          setTimeout(() => {
            let offSetTop =
              this.scrollPos?.current?.childNodes[0]?.childNodes[0]
                ?.childNodes[1]?.childNodes[rowIndex]?.offsetTop - 96;
            this.scrollPos?.current?.childNodes[0]?.scrollTo({
              top: offSetTop,
              behavior: "smooth",
            });
          }, 50);
        } else {
          setTimeout(() => {
            let offSetTop =
              this.scrollPos?.current?.childNodes[0]?.childNodes[0]
                ?.childNodes[1]?.childNodes[rowIndex]?.offsetTop - 48;
            this.scrollPos?.current?.childNodes[0]?.scrollTo({
              top: offSetTop,
              behavior: "smooth",
            });
          }, 50);
        }
      }

      return { data: newData, isModified: true };
    });
  };

  handleAmountOnFocus = (field, event, itemUniqueNo) => {
    const { data } = this.state;
    const index = data.findIndex((x: any) => x.itemUniqueNo === itemUniqueNo);

    let newval = !event.target.value
      ? ""
      : Utils.currencyFormatWithoutDollar(event.target.value);

    const _data = _.cloneDeep(data);
    _data[index][field] = newval;
    this.setState({ data: _data });
  };
  handleAmountOnBlur = (field, event, itemUniqueNo) => {
    const { data } = this.state;
    const index = data.findIndex((x: any) => x.itemUniqueNo === itemUniqueNo);

    const _data = _.cloneDeep(data);
    if (!isNaN(event.target.value)) {
      let fieldValue = !event.target.value
        ? ""
        : Utils.currencyFormatWithoutDollar(data[index][field]);
      _data[index][field] = fieldValue;
    }
    this.setState({ data: _data });
  };

  handleSave = async () => {
    let { data, hideDebitCredit }: any = this.state;
    const { filterHotelId, selectedDate } = this.props;

    const modifiedRows = data.filter((row) => row.isModified);

    if (modifiedRows?.length === 0) {
      toast.info("No changes to save");
      return;
    }

    this.setState({ isDataSaving: true });
    const entries: IRevenueEntryRequest[] = modifiedRows.map((entry) => ({
      BackHid: filterHotelId,
      Date: selectedDate,
      UniqueNo: entry.uniqueNo || 0,
      ItemNo: entry.itemNo,
      ItemName: entry.itemName,
      Amount: entry.amount || 0,
      DebitAmount: entry.debitAmount || 0,
      CreditAmount: entry.creditAmount || 0,
      COA: entry.coa || "",
      Sno: entry.sno || 0,
      BrandCode: entry.brandCode || 0,
      VersionCode: entry.versionCode || 0,
      ItemUniqueNo: entry.itemUniqueNo || 0,
      EntryType: +this.props.type == 2 ? "Single" : entry.entryType || "",
      TypeID: this.props.type || 0,
      Explanation: entry.explanation || "",
      ExplanationReq: entry.explanationReq || "",
      UserToken: "",
    }));
    if (entries?.length > 0) {
      const entriesThatHaveExplanationNotFilled = entries.filter(
        (x: any) =>
          x.ExplanationReq == "yes" &&
          (hideDebitCredit
            ? Number(x.Amount) > 0
            : Number(x.DebitAmount) > 0 || Number(x.CreditAmount) > 0) &&
          !x.Explanation?.toString()?.trim()
      );
      if (entriesThatHaveExplanationNotFilled?.length > 0) {
        data = data.map((x) => {
          if (
            entriesThatHaveExplanationNotFilled.find(
              (y) => y.ItemName == x.itemName
            )
          ) {
            x.showExplanationRequired = true;
          } else {
            x.showExplanationRequired = false;
          }

          return x;
        });
        this.setState({ data, isDataSaving: false });
        toast.error(`Please provide explanation in the required fields`);
        return;
      }
    }
    const totalCreditAmount = data.reduce(
      (acc, item: any) =>
        acc +
        (+Utils.removeInvaildCharFromAmount(item?.creditAmount || 0) || 0),
      0
    );
    const totalDebitAmount = data.reduce(
      (acc, item: any) =>
        acc + (+Utils.removeInvaildCharFromAmount(item?.debitAmount || 0) || 0),
      0
    );

    const totalAmount = data.reduce(
      (acc, item: any) =>
        acc + (+Utils.removeInvaildCharFromAmount(item?.amount || 0) || 0),
      0
    );

    const payload: IRevenuePostRequest = {
      totalPMS:
        entries[0].EntryType == "Single" || entries[0].TypeID == 2
          ? totalAmount
          : totalDebitAmount - totalCreditAmount,
      totalDetails:
        entries[0].EntryType == "Single" || entries[0].TypeID == 2
          ? totalAmount
          : totalDebitAmount - totalCreditAmount,
      variance: "0",
      requests: entries,
    };

    try {
      const response: any = await DailyActivityService.saveRevenueEntry(
        payload
      );
      const { isSuccess, errorMessage, failedCount, failedEntries } = response;

      if (!isSuccess && errorMessage) {
        toast.error(errorMessage);
      } else if (failedCount > 0) {
        if (failedEntries[0]?.errorMessage) {
          toast.error(failedEntries[0]?.errorMessage);
        } else {
          toast.error(`${failedCount} entries failed to save.`);
        }
      } else {
        toast.success("Data saved successfully");
      }
      this.props.setCurrentTabStatusOnValuesChanges(false);
      this.setState({ isModified: false });
      this.fetchRevenueData();
      this.props.refreshMainData();
    } catch (error) {
      toast.error("Failed to insert data");
    } finally {
      this.setState({ isDataSaving: false });
    }
  };
  handleDiscard = () => {
    this.props.setCurrentTabStatusOnValuesChanges(false);
    this.setState({ isModified: false });
    this.fetchRevenueData();
  };

  getFilteredData = () => {
    const { hideDebitCredit, searchTerm, hideEmptyRows, data } = this.state;
    let filteredData = _.cloneDeep(data);

    if (hideDebitCredit) {
      filteredData = hideEmptyRows
        ? filteredData.filter((row: any) => row?.amount)
        : filteredData;
    } else {
      filteredData = hideEmptyRows
        ? filteredData.filter(
            (row: any) => row?.debitAmount || row?.creditAmount
          )
        : filteredData;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    filteredData = filteredData.filter((row: any) => {
      return (
        row.itemNo?.toString().toLowerCase().includes(lowerSearchTerm) ||
        row.itemName?.toLowerCase().includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.debitAmount, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.creditAmount, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        Utils.removeInvaildCharFromAmount(row?.amount, 16)
          ?.toString()
          .toLowerCase()
          .includes(lowerSearchTerm) ||
        row?.debitAmount?.toString().toLowerCase().includes(lowerSearchTerm) ||
        row?.creditAmount?.toString().toLowerCase().includes(lowerSearchTerm) ||
        row?.amount?.toString().toLowerCase().includes(lowerSearchTerm) ||
        row.explanation?.toLowerCase().includes(lowerSearchTerm) ||
        row.description?.toLowerCase().includes(lowerSearchTerm)
      );
    });

    return filteredData;
  };

  renderDescriptionWithTooltip = (row) => {
    return row?.description?.toString()?.trim()?.length > 0 ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-description-${row?.itemUniqueNo}`}>
            {row?.description}
          </Tooltip>
        }
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.25 5.25H9.75V6.75H8.25V5.25ZM8.25 8.25H9.75V12.75H8.25V8.25ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z"
            fill="#6A6E73"
          />
        </svg>
      </OverlayTrigger>
    ) : (
      <></>
    );
  };

  preventInvalidKeys = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const invalidKeys = ["e", "E", "+"];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  borderFormatter = (column, colIndex) => {
    return (
      <>
        {column.text}
        <div className="border-bottom"></div>
      </>
    );
  };
  borderFooterFormatter = (column, colIndex, { text }) => {
    return (
      <>
        <div className="border-top"></div>
        <div className="border-bottom"></div>
      </>
    );
  };

  getColumns = () => {
    const { searchTerm } = this.state;
    if (this.getFilteredData()?.length === 0 || searchTerm?.trim()) {
      return this.getColumnWithoutFooter();
    } else {
      return this.getColumnsWithFooter();
    }
  };
  getColumnsWithFooter = () => {
    const { hideDebitCredit, data, isDataSaving } = this.state;
    let baseColumns: any[] = [
      {
        dataField: "itemNo",
        text: "Item No.",
        headerClasses: "short-code-width",
        footer: "Totals",
        headerFormatter: this.borderFormatter,
        footerFormatter: (column, colIndex, { text }) => (
          <>
            <div className="lable">{"Totals"}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        ),
      },
      {
        dataField: "itemName",
        text: "Item Name",
        headerClasses: "big-code-width",
        headerFormatter: this.borderFormatter,
        formatter: (cell, row) => (
          <EllipsisWithTooltip placement="bottom">
            {row.itemName}
          </EllipsisWithTooltip>
        ),
        footer: "",
        footerFormatter: this.borderFooterFormatter,
      },
    ];

    if (hideDebitCredit) {
      baseColumns.push({
        dataField: "",
        text: "Total",
        headerClasses: "align-right width-140",
        headerFormatter: this.borderFormatter,
        classes: "align-right",
        formatter: (cell, row) => (
          // <InputeEllipisWithTooltip
          //   placement="bottom"
          //   inputeVal={row?.amount || ""}
          // >
          <Form.Control
            className="width-124 text-right"
            type="text"
            onKeyDown={this.preventInvalidKeys}
            value={row?.amount || ""}
            maxLength={16}
            onFocus={(e) =>
              this.handleAmountOnFocus("amount", e, row.itemUniqueNo)
            }
            onBlur={(e) =>
              this.handleAmountOnBlur("amount", e, row.itemUniqueNo)
            }
            onChange={(e) =>
              this.handleInputChange(
                e,
                e.target.value,
                row.itemUniqueNo,
                "amount"
              )
            }
          />
          //  </InputeEllipisWithTooltip>
        ),
        footer: (columnData) => columnData.reduce((acc, item) => acc + item, 0),
        footerAlign: (column, colIndex) => "right",
        footerFormatter: (column, colIndex, { text }) => (
          <>
            <div className="value">
              <EllipsisWithTooltip placement="bottom">
                $
                {Utils.currencyFormatWithOutdoller(
                  data.reduce(
                    (acc, item: any) =>
                      acc +
                      (+Utils.removeInvaildCharFromAmount(item?.amount) || 0),
                    0
                  )
                )}
              </EllipsisWithTooltip>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        ),
      });
    } else {
      baseColumns.push(
        {
          dataField: "",
          text: "Debit",
          headerClasses: "align-right width-140",
          classes: "align-right",
          headerFormatter: this.borderFormatter,
          formatter: (cell, row) => (
            // <InputeEllipisWithTooltip
            //   placement="bottom"
            //   inputeVal={row?.debitAmount || ""}
            // >
            <Form.Control
              className="width-124 text-right"
              type="text"
              maxLength={16}
              onKeyDown={this.preventInvalidKeys}
              value={row?.debitAmount || ""}
              onFocus={(e) =>
                this.handleAmountOnFocus("debitAmount", e, row.itemUniqueNo)
              }
              onBlur={(e) =>
                this.handleAmountOnBlur("debitAmount", e, row.itemUniqueNo)
              }
              onChange={(e) =>
                this.handleInputChange(
                  e,
                  e.target.value,
                  row.itemUniqueNo,

                  "debitAmount"
                )
              }
            />
            // </InputeEllipisWithTooltip>
          ),
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerAlign: (column, colIndex) => "right",
          footerFormatter: (column, colIndex, { text }) => (
            <>
              <div className="value">
                <EllipsisWithTooltip placement="bottom">
                  $
                  {Utils.currencyFormatWithOutdoller(
                    data.reduce(
                      (acc, item: any) =>
                        acc +
                        (+Utils.removeInvaildCharFromAmount(
                          item?.debitAmount
                        ) || 0),
                      0
                    )
                  )}
                </EllipsisWithTooltip>
              </div>
              <div className="border-top"></div>
              <div className="border-bottom"></div>
            </>
          ),
        },
        {
          dataField: "",
          text: "Credit",
          headerClasses: "align-right width-140",
          classes: "align-right",
          headerFormatter: this.borderFormatter,
          formatter: (cell, row) => (
            // <InputeEllipisWithTooltip
            //   placement="bottom"
            //   inputeVal={row?.creditAmount || ""}
            // >
            <Form.Control
              className="width-124 text-right"
              type="text"
              maxLength={16}
              onKeyDown={this.preventInvalidKeys}
              value={row?.creditAmount || ""}
              onFocus={(e) =>
                this.handleAmountOnFocus("creditAmount", e, row.itemUniqueNo)
              }
              onBlur={(e) =>
                this.handleAmountOnBlur("creditAmount", e, row.itemUniqueNo)
              }
              onChange={(e) =>
                this.handleInputChange(
                  e,
                  e.target.value,
                  row.itemUniqueNo,

                  "creditAmount"
                )
              }
            />
            // </InputeEllipisWithTooltip>
          ),
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerAlign: (column, colIndex) => "right",
          footerFormatter: (column, colIndex, { text }) => (
            <>
              <div className="value">
                <EllipsisWithTooltip placement="bottom">
                  $
                  {Utils.currencyFormatWithOutdoller(
                    data.reduce(
                      (acc, item: any) =>
                        acc +
                        (+Utils.removeInvaildCharFromAmount(
                          item?.creditAmount
                        ) || 0),
                      0
                    )
                  )}
                </EllipsisWithTooltip>
              </div>
              <div className="border-top"></div>
              <div className="border-bottom"></div>
            </>
          ),
        }
      );
    }

    baseColumns.push(
      {
        dataField: "",
        text: "Explanation",
        headerClasses: "notes-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
        footer: "",
        formatter: (cell, row) => (
          <>
            {row?.explanationReq == "yes" ? (
              <InputeEllipisWithTooltip
                placement="bottom"
                inputeVal={row?.explanation || ""}
              >
                <Form.Control
                  maxLength={900}
                  value={row?.explanation || ""}
                  className={
                    row?.explanationReq == "yes" &&
                    !row?.explanation &&
                    (hideDebitCredit
                      ? Number(row?.amount) > 0
                      : Number(row?.debitAmount) > 0 ||
                        Number(row?.creditAmount) > 0)
                      ? "notes red-border"
                      : "notes"
                  }
                  onChange={(e) =>
                    this.handleInputChange(
                      e,
                      e.target.value,
                      row.itemUniqueNo,
                      "explanation"
                    )
                  }
                />
              </InputeEllipisWithTooltip>
            ) : (
              <span>{row?.explanation}</span>
            )}
          </>
        ),
      },
      {
        dataField: "description",
        text: "",
        headerClasses: "info-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
        footer: "",
        formatter: (cell, row) => this.renderDescriptionWithTooltip(row),
      }
    );

    return baseColumns;
  };

  getColumnWithoutFooter = () => {
    const { hideDebitCredit, data, isDataSaving } = this.state;
    let baseColumns: any[] = [
      {
        dataField: "itemNo",
        text: "Item No.",
        headerClasses: "short-code-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
      },
      {
        dataField: "itemName",
        text: "Item Name",
        headerClasses: "big-code-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
      },
    ];

    if (hideDebitCredit) {
      baseColumns.push({
        dataField: "",
        text: "Total",
        headerClasses: "align-right width-140",
        classes: "align-right",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
        formatter: (cell, row) => (
          // <InputeEllipisWithTooltip
          //   placement="bottom"
          //   inputeVal={row?.amount || ""}
          // >
          <Form.Control
            className="width-124 text-right"
            type="text"
            maxLength={16}
            onKeyDown={this.preventInvalidKeys}
            value={row?.amount || ""}
            onFocus={(e) =>
              this.handleAmountOnFocus("amount", e, row.itemUniqueNo)
            }
            onBlur={(e) =>
              this.handleAmountOnBlur("amount", e, row.itemUniqueNo)
            }
            onChange={(e) =>
              this.handleInputChange(
                e,
                e.target.value,
                row.itemUniqueNo,
                "amount"
              )
            }
          />
          // </InputeEllipisWithTooltip>
        ),
      });
    } else {
      baseColumns.push(
        {
          dataField: "",
          text: "Debit",
          headerClasses: "align-right width-140",
          classes: "align-right",
          headerFormatter: this.borderFormatter,
          footerFormatter: this.borderFooterFormatter,
          formatter: (cell, row) => (
            // <InputeEllipisWithTooltip
            //   placement="bottom"
            //   inputeVal={row?.debitAmount || ""}
            // >
            <Form.Control
              className="width-124 text-right"
              type="text"
              maxLength={16}
              onKeyDown={this.preventInvalidKeys}
              value={row?.debitAmount || ""}
              onFocus={(e) =>
                this.handleAmountOnFocus("debitAmount", e, row.itemUniqueNo)
              }
              onBlur={(e) =>
                this.handleAmountOnBlur("debitAmount", e, row.itemUniqueNo)
              }
              onChange={(e) =>
                this.handleInputChange(
                  e,
                  e.target.value,
                  row.itemUniqueNo,
                  "debitAmount"
                )
              }
            />
            // </InputeEllipisWithTooltip>
          ),
        },
        {
          dataField: "",
          text: "Credit",
          headerClasses: "align-right width-140",
          classes: "align-right",
          headerFormatter: this.borderFormatter,
          footerFormatter: this.borderFooterFormatter,
          formatter: (cell, row) => (
            // <InputeEllipisWithTooltip
            //   placement="bottom"
            //   inputeVal={row?.creditAmount || ""}
            // >
            <Form.Control
              className="width-124 text-right"
              type="text"
              maxLength={16}
              onKeyDown={this.preventInvalidKeys}
              value={row?.creditAmount || ""}
              onFocus={(e) =>
                this.handleAmountOnFocus("creditAmount", e, row.itemUniqueNo)
              }
              onBlur={(e) =>
                this.handleAmountOnBlur("creditAmount", e, row.itemUniqueNo)
              }
              onChange={(e) =>
                this.handleInputChange(
                  e,
                  e.target.value,
                  row.itemUniqueNo,
                  "creditAmount"
                )
              }
            />
            // </InputeEllipisWithTooltip>
          ),
        }
      );
    }

    baseColumns.push(
      {
        dataField: "",
        text: "Explanation",
        headerClasses: "notes-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
        formatter: (cell, row) => (
          <>
            {row?.explanationReq == "yes" ? (
              <InputeEllipisWithTooltip
                placement="bottom"
                inputeVal={row?.explanation || ""}
              >
                <Form.Control
                  value={row?.explanation || ""}
                  maxLength={900}
                  className={
                    row?.explanationReq == "yes" &&
                    !row?.explanation &&
                    (hideDebitCredit
                      ? Number(row?.amount) > 0
                      : Number(row?.debitAmount) > 0 ||
                        Number(row?.creditAmount) > 0)
                      ? "notes red-border"
                      : "notes"
                  }
                  onChange={(e) =>
                    this.handleInputChange(
                      e,
                      e.target.value,
                      row.itemUniqueNo,
                      "explanation"
                    )
                  }
                />
              </InputeEllipisWithTooltip>
            ) : (
              <span>{row?.explanation}</span>
            )}
          </>
        ),
      },
      {
        dataField: "description",
        text: "",
        headerClasses: "info-width",
        headerFormatter: this.borderFormatter,
        footerFormatter: this.borderFooterFormatter,
        formatter: (cell, row) => this.renderDescriptionWithTooltip(row),
      }
    );

    return baseColumns;
  };
  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };

  render() {
    const {
      searchTerm,
      hideEmptyRows,
      isModified,
      isDataLoading,
      isDataSaving,
    } = this.state;
    return (
      <>
        {isDataLoading ? (
          <ReactPageLoader useas={"revenue-nonrevenue"} />
        ) : (
          <div className="payment-section  reuse-sub-design">
            <div className="filter-section d-flex">
              <div className="search-input">
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) =>
                    this.setState({ searchTerm: e.target.value })
                  }
                />
              </div>

              <div className="ml-auto">
                <div className="togglebtn d-flex align-items-center">
                  <div className="label">Hide Empty Rows</div>
                  <Form.Check
                    id="showInactive"
                    key="showInactive"
                    type="switch"
                    label=""
                    checked={hideEmptyRows}
                    onChange={() =>
                      this.setState({ hideEmptyRows: !hideEmptyRows })
                    }
                  />
                </div>
              </div>
            </div>
            <div
              ref={this.scrollPos}
              className={`body-section tbl-footer ${
                isModified ? "footer-exist" : ""
              }`}
              onWheel={() => this.hoverOutEllipsis()}
            >
              <BootstrapTable
                keyField="itemUniqueNo"
                data={this.getFilteredData()}
                columns={this.getColumns()}
              />
            </div>
            {isModified && (
              <div className="footer-section d-flex align-items-center">
                <div className="msg">You have unsaved changes</div>
                <div className="ml-auto action">
                  <Button
                    variant="primary"
                    type="button"
                    disabled={isDataSaving}
                    role="tab" tabIndex={1}
                    onClick={() =>
                      confirmAlert({
                        title: "Unsaved Changes",
                        message:
                          "You have unsaved changes. Do you want to discard them?",
                        buttons: [
                          {
                            label: "Yes",
                            onClick: () => this.handleDiscard(),
                          },
                          { label: "No", onClick: () => {} },
                        ],
                      })
                    }
                    className="space btn btn-primary btn-discard"
                  >
                    Discard
                  </Button>
                  <Button
                  role="tab" tabIndex={0}
                    variant="primary"
                    type="button"
                    disabled={isDataSaving}
                    onClick={this.handleSave}
                    className="btn btn-primary"
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}
export default RevenueNonRevenue;
